import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { useNavigate } from 'react-router-dom';

const IndividualClient = () => {
    const [filteredUsers, setFilteredUsers] = useState([]);

    const navigate = useNavigate();
    const BaseUrl = process.env.REACT_APP_API;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = sessionStorage.getItem('AuthToken');

                const response = await fetch(`${BaseUrl}/individual-client-list-director-dashboard`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                const data = await response.json();
                setFilteredUsers(data);
            } catch (error) {
                console.error("Failed to fetch users:", error);
            }
        };

        fetchData();
    }, [BaseUrl, navigate]);

    useEffect(() => {
        if (filteredUsers.length > 0) {
            const table = $('#dataTable').DataTable({
                destroy: true, // Prevent multiple instances
                pageLength: 10,
            });
            return () => {
                table.destroy();
            };
        }
    }, [filteredUsers]);

    return (
        <div className="card basic-data-table">
            <div className="card-body">
            <div className="table-responsive">

                <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
                    <thead>
                        <tr>
                            <th scope="col">S.L</th>
                            <th scope="col">Name</th>
                            <th scope="col">Total Quantity</th>
                            <th scope="col">Average NAV</th>
                            <th scope="col">Total Amount</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map((user, index) => (
                            <tr key={user.id}>
                                <td>{index + 1}</td>
                                <td>{user.full_legal_name}</td>
                                <td>{user.total_quantity || 'N/A'}</td>
                                <td>{user.average_nav_price || 'N/A'}</td>
                                <td>{user.total_amount || 'N/A'}</td>
                                <td>
                                    <button 
                                        onClick={() => navigate(`/digital-asset/ind-client-details/${user.person_id}`)} 
                                        className="btn btn-primary"
                                    >
                                        View Details
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    );
};

export default IndividualClient;
